import React, { useState } from 'react';
import styled from 'styled-components';

const Heading = styled.div`
    font-size: 20px;
    font-weight: 700;
    color: #5562C0;
    margin-bottom: 6px;
`;

const Subtitle = styled.div`
    font-size: 14px;
    color: #6A6D90;
    margin-bottom: 20px;
`;

const CopyRow = styled.div`
    display: flex;
    gap: 8px;
    margin-bottom: 24px;
`;

const UrlDisplay = styled.div`
    flex: 1;
    padding: 10px 14px;
    border: 1px solid #CECEDC;
    border-radius: 4px;
    font-size: 13px;
    color: #444;
    background: #f9f9f9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
`;

const CopyButton = styled.button`
    background: #5562C0;
    color: white;
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 700;
    border: 0;
    cursor: pointer;
    white-space: nowrap;
`;

const SectionLabel = styled.div`
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #888;
    margin-bottom: 12px;
    text-align: left;
`;

const ShareButtons = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
`;

const ShareButton = styled.button`
    flex: 1;
    padding: 11px 10px;
    border-radius: 4px;
    border: 0;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    background: ${props => props.bg || '#f0f0f0'};
    color: ${props => props.textColor || '#222'};
`;

const CloseLink = styled.div`
    font-size: 13px;
    color: #888;
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
`;

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalBox = styled.div`
    background: white;
    width: 500px;
    padding: 28px 32px;
    box-sizing: border-box;
    box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.33);
    text-align: left;
`;

export default function ShareModal({ isInstructor, onClose }) {
    const [copied, setCopied] = useState(false);

    const url = isInstructor
        ? 'https://teachwithmuze.com'
        : 'https://learnwithmuze.com';

    const twitterMessage = encodeURIComponent(
        `I've been using Muze for music lessons — check it out! ${url}`
    );

    const emailSubject = encodeURIComponent('Check out Muze for music lessons');
    const emailBody = encodeURIComponent(
        isInstructor
            ? `I've been using Muze to manage my music lessons — thought you might like it: ${url}`
            : `I've been taking music lessons on Muze — you should check it out: ${url}`
    );

    const handleCopy = () => {
        navigator.clipboard.writeText(url).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch(() => {
            // Clipboard API unavailable (non-HTTPS context) — no action
        });
    };

    const handleTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${twitterMessage}`, '_blank');
    };

    const handleFacebook = () => {
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
            '_blank'
        );
    };

    const handleEmail = () => {
        window.open(`mailto:?subject=${emailSubject}&body=${emailBody}`, '_self');
    };

    return (
        <Overlay onClick={onClose}>
            <ModalBox onClick={e => e.stopPropagation()}>
                <Heading>Share Muze</Heading>
                <Subtitle>Know someone who'd love it? Send them the link.</Subtitle>

                <CopyRow>
                    <UrlDisplay>{url}</UrlDisplay>
                    <CopyButton onClick={handleCopy}>
                        {copied ? 'Copied!' : 'Copy Link'}
                    </CopyButton>
                </CopyRow>

                <SectionLabel>Or share via</SectionLabel>
                <ShareButtons>
                    <ShareButton onClick={handleEmail} bg="#f0f0f0" textColor="#222">
                        ✉️ Email
                    </ShareButton>
                    <ShareButton onClick={handleTwitter} bg="#000000" textColor="#ffffff">
                        𝕏 Twitter
                    </ShareButton>
                    <ShareButton onClick={handleFacebook} bg="#1877F2" textColor="#ffffff">
                        Facebook
                    </ShareButton>
                </ShareButtons>

                <CloseLink onClick={onClose}>Close</CloseLink>
            </ModalBox>
        </Overlay>
    );
}
